import React, { useEffect, useState } from "react";
import { FiShoppingBag, FiUser, FiPhone, FiMapPin } from "react-icons/fi";
import "./AdminOrders.css";

const API_BASE = "https://api.thetotetherapy.com";

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      const res = await fetch(`${API_BASE}/api/orders`);
      const data = await res.json();
      setOrders(data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="adminState">Loading orders...</div>;

  return (
    <main className="adminOrdersPage">
      <h2 className="adminOrdersTitle">
        <FiShoppingBag /> Customer Orders ({orders.length})
      </h2>

      {orders.length === 0 ? (
        <div className="adminState">No orders yet.</div>
      ) : (
        <div className="ordersGrid">
          {orders.map(order => (
            <div className="orderCard" key={order.id}>
              <div className="paymentInfo">
  <p>Payment Status: {order.payment_status || "Not Confirmed"}</p>
  {order.stripe_session_id && (
    <p>Stripe ID: {order.stripe_session_id}</p>
  )}
</div>
            <div className="orderTop">
  <h3>Order #{order.id}</h3>

  <div className="orderMeta">
    <span className="orderDate">
      {new Date(order.created_at).toLocaleString()}
    </span>

    <span
      className={
        order.status === "PAID"
          ? "statusBadge paid"
          : "statusBadge pending"
      }
    >
      {order.status}
    </span>
  </div>
</div>

              <div className="orderUser">
                <p><FiUser /> {order.name}</p>
                <p><FiPhone /> {order.phone}</p>
                <p><FiMapPin /> {order.address}</p>
                <p>Email: {order.email}</p>
              </div>

              <div className="orderItems">
                {order.items.map(item => (
                  <div key={item.id} className="orderItem">
                    <span>{item.title} × {item.quantity}</span>
                    <span>AED {(item.price * item.quantity).toFixed(2)}</span>
                  </div>
                ))}
              </div>

              <div className="orderTotal">
                Total: AED {order.total}
              </div>
            </div>
          ))}
        </div>
      )}
    </main>
  );
}